import React from 'react'

export default function Cancel() {
  return (
    <div>cancel</div>
  )
}
